// File: cgp-app-bar-menu-component.ts
// Author: James L Seebach
// Date: 5/12/2017
// Desc: CGP App Bar Menu component.
// Other Contributors:

import { Component, OnInit, ViewChild } from '@angular/core';
import { CgpUserProfileDialogService } from '../../cgp-user-profile-dialog/cgp-user-profile-dialog.service';
import { MatMenuTrigger } from '@angular/material/menu';

import { cgpAuthentication } from '../../../../modules/cgp-authentication';
import { config } from "../../../../config/config";

@Component({
    selector: 'cgp-app-bar-menu',
    templateUrl: './cgp-app-bar-menu.template.html'
})
export class CgpAppBarMenuComponent implements OnInit {

    @ViewChild(MatMenuTrigger, { static: true }) trigger: MatMenuTrigger;

    username;
    menuIcon;
    menuItems;
    userGmin;

    constructor(
        private readonly cgpUserProfileDialogService: CgpUserProfileDialogService,
    ) { }

    ngOnInit() {
        this.bindEvents();
        this.menuIcon = "fa fa-user";
        this.menuItems = config.appBarMenuItems;
        const userInfo = cgpAuthentication.getUserInfo();
        if (userInfo) {
            this.username = userInfo.cn;
            this.userGmin = userInfo.gmuniqueidentifier;
        }
    }

    menuActions = (action) => {

        switch (action) {
            case "openProfileDialog":
                this.onShowUserProfileClick();
                break;
            case "logOut":
                window.location.href = "#/logged-out";
                break;
            case 'helpLink':
                break;
            default:
                //Remove default at production if desired
                alert("No matching function found");
        }
    }

    onShowUserProfileClick = () => {
        this.cgpUserProfileDialogService.showUserProfileDialog({
            title: "User Profile",
            closeLabel: "Close"
        });
    }

    bindEvents = () => {
        this.trigger.menuOpened.subscribe(() => {
            //Function calls or custom events to trigger on menu open go here
        });
        this.trigger.menuClosed.subscribe(() => {
            //Function calls or custom events to trigger on menu close go here
        });
    }
}
